import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { IconShapeArrowDown } from '@xingternal/malt-icon';

import styles from './Accordion.css';

export default class ToggleSection extends Component {
  static displayName = 'ToggleSection';

  static propTypes = {
    header: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired,
    update: PropTypes.func,
    slave: PropTypes.bool,
    initiallyOpen: PropTypes.bool,
    open: PropTypes.bool,
    className: PropTypes.string,
  };

  static defaultProps = {
    update: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      open: !!this.props.initiallyOpen,
    };
  }

  toggle() {
    if (this.props.slave && typeof this.props.update === 'function') {
      this.props.update(!this.props.open);
    } else {
      this.setState({
        open: !this.state.open,
      });
    }
  }

  render() {
    const open = this.props.slave ? !!this.props.open : this.state.open;

    const content = open ? (
      <div className={styles.content}>{this.props.children}</div>
    ) : null;

    const classes = classNames(styles.header, { [styles.open]: open });

    return (
      <article className={this.props.className}>
        <header onClick={this.toggle.bind(this)} className={classes}>
          <span className={styles.text}>{this.props.header}</span>
          <IconShapeArrowDown className={styles.icon} />
        </header>
        {content}
      </article>
    );
  }
}
